export default __webpack_public_path__ + "static/media/mapa.7422fb41.jpeg";